module.exports = __webpack_public_path__ + "img/arrow-btn-cupo.a858309c.svg";